import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ALLOW_IDENTIFIED_USER_FETCH_PETITION_LISTS = createFcmDetails(
	'allow_identified_user_fetch_petition_lists',
	{
		owner: 'Site Platform',
		context: 'User Profile',
		description:
			'If true, the current user can see their signed and started petitions even if they are only identified.',
		import: false,
	},
);
